import React from 'react';

import { Input, Checkbox } from '../../components/Input.components';
import { Grid } from '../../components/Grid.components';
import { Boxed } from '../../components/Boxed.components';
import { Text } from '../../components/Text.components';
import { Button } from '../../components/Button.components';

import { calcViewMode } from '../../utils/utils';

import LOGO from '../../assets/img/logo.png';

import { Theme } from '../../utils/theme';

export const Login = (props) => {
  const { form, isLoading, login, redirect } = props;
  const { getFieldProps, getFieldError, validateFields } = form;
  let viewMode = calcViewMode();

  const onLogin = () => {
    validateFields((error, value) => {
      if (!error) {
        const data = {
          email: value.username.trim(),
          password: value.password
        };
        login(data);
      }
    });
  };

  const onEnter = (e) => {
    e.stopPropagation();
    e.key === 'Enter' && onLogin();
  };

  return (
    <>
      <Grid desktop="100%" tablet="100%" mobile="100%">
        <Boxed display="flex" width="100%" minHeight="100vh">
          <Boxed margin="auto" minWidth="350px">
            <Boxed pad="10px 0" display="flex">
              <img src={LOGO} height="100px" alt="app_logo"  style={{ margin: "0 auto" }} />
            </Boxed>
            <Boxed pad="20px" background='#FFFFFF' borderRadius={Theme.SecondaryRadius} boxShadow={Theme.PrimaryShadow}>
              <Text fontSize="24px" fontWeight="bold" margin="5px 0">
                Sign In
              </Text>
              <Text margin="5px 0">Please log in to your account.</Text>
              <Boxed margin="20px 0">
                <Input
                  label="Email"
                  type="email"
                  placeholder="Your Email..."
                  error={getFieldError('username') ? 'Email is required' : null}
                  {...getFieldProps('username', {
                    initialValue: '',
                    rules: [{ required: true, type: 'email' }]
                  })}
                />
              </Boxed>
              <Boxed margin="20px 0">
                <Input
                  label="Password"
                  type="password"
                  placeholder="Your Password..."
                  onKeyPress={onEnter}
                  error={getFieldError('password') ? 'Password is required' : null}
                  {...getFieldProps('password', {
                    initialValue: '',
                    rules: [{ required: true }]
                  })}
                />
              </Boxed>
              <Boxed pad="10px">
                <Text cursor='pointer' onClick={() => redirect('/forgotpassword')}>Forgot password?</Text>
              </Boxed>
                <Boxed pad="5px 0 0 0" display="flex">
                <Button clear onClick={() => redirect('/signup')}>
                    SIGN UP
                  </Button>
                  <Button margin="0 0 0 auto" disabled={isLoading} progress={isLoading} onClick={onLogin}>
                    SIGN IN
                  </Button>
                </Boxed>
            </Boxed>
          </Boxed>
        </Boxed>
      </Grid>
    </>
  );
};
